import BaseProxy from './Proxy';

export default class SubstoreCatalogueProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/catalogue', parameters);
  }
}
